import { render, staticRenderFns } from "./TusClient.vue?vue&type=template&id=296cf906&scoped=true"
import script from "./TusClient.vue?vue&type=script&lang=js"
export * from "./TusClient.vue?vue&type=script&lang=js"
import style0 from "./TusClient.vue?vue&type=style&index=0&id=296cf906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296cf906",
  null
  
)

export default component.exports